import { create } from "zustand";

interface ChatbotStoreType {
  isChatbotOpen: boolean;
  setIsChatbotOpen: (newIsChatbotOpen: boolean) => void;
}

const useChatbotStore = create<ChatbotStoreType>((set, get) => ({
  isChatbotOpen: false,

  setIsChatbotOpen: (newIsChatbotOpen: boolean) => {
    set({ isChatbotOpen: newIsChatbotOpen });
  },
}));

export default useChatbotStore;
